import { PlainWidgetDecoration } from "@/lib/gql/__generated__/graphql";

import { DEFAULT_VALUES } from "@/components/features/design/plain/model/constants";
import type * as FormModelType from "@/components/features/design/plain/model/type";

import * as Composition from "./composition";

export const serverModelToInputModelConverter = (
	queryData: FormModelType.QueryData,
): FormModelType.PlainSettingFormModel["InputModel"] => {
	const domainName = queryData.plainSetting.domainName ?? "";
	return {
		hotelID: queryData.plainSetting.hotelID,
		// URL 設定
		domainName,
		subDomainName: Composition.Extract.extractSubdomainFromDomainName(domainName),

		// 基本設定
		// 色の設定
		// 背景色の設定
		colorBackground: queryData.plainSetting.colorBackground || DEFAULT_VALUES.colorBackground,
		// テーマカラーの設定
		colorPrimary: queryData.plainSetting.colorPrimary || DEFAULT_VALUES.colorPrimary,
		// 文字色の設定
		colorFont: queryData.plainSetting.colorFont || DEFAULT_VALUES.colorFont,
		// 施設情報の表示・非表示
		isShowHotelName: queryData.plainSetting.isShowHotelName,
		// キャッチコピーの表示・非表示
		isShowHotelCatchCopy: queryData.plainSetting.isShowHotelCatchCopy,
		// ホテルロゴ
		logoImage: queryData.plainSetting.logoImage,
		// ホテルロゴのサイズ
		logoSize: queryData.plainSetting.logoSize || DEFAULT_VALUES.logoSize,
		// ホテルロゴの表示・非表示
		isShowHotelLogo: queryData.plainSetting.isShowHotelLogo,
		// キービジュアル
		isShowHotelKeyVisual: queryData.plainSetting.isShowHotelKeyVisual,
		// フォント設定
		fontFamily: queryData.plainSetting.fontFamily || DEFAULT_VALUES.fontFamily,
		// 予約パーツの設定
		reservationComponentType:
			queryData.plainSetting.reservationComponentType || DEFAULT_VALUES.reservationComponentType,

		// スナック
		// スナックの追加
		plainWidgetDefault: {
			hotelID: queryData.plainSetting.hotelID,
			widgetItems: [...queryData.plainWidgetDefault.widgetItems],
		},
		// スナックの枠の設定
		widgetDecoration: queryData.plainSetting.widgetDecoration || PlainWidgetDecoration.None,
		// マガジンの追加
		// 施設記事の表示・非表示
		isShowMagazineAbout: queryData.plainSetting.isShowMagazineAbout,
		// プラン記事の表示・非表示
		isShowMagazinePlan: queryData.plainSetting.isShowMagazinePlan,
		// 部屋の記事の表示・非表示
		isShowMagazineRoom: queryData.plainSetting.isShowMagazineRoom,

		// 検索エンジンへの表示（プレーンの公開状態）
		guestPageVisibility: queryData.guestPageVisibilitySettings.plainVisibility,

		// 分析の設定
		// GTM の設定
		gtmID: queryData.plainSetting.gtmID,

		//
		backgroundType: queryData.plainSetting.backgroundType || DEFAULT_VALUES.backgroundType,
		backgroundImage: queryData.plainSetting.backgroundImage,
	} satisfies FormModelType.PlainSettingFormModel["InputModel"];
};
